<template>
  <div class="gains">
    <child-header bg="blue" v-bind:title="title" v-bind:main="main"></child-header>
    <ul class="people_info">
      <router-link to="/gainsdetail">
        <li v-for="item in items" @click="toDetail(item.id)">
          <div class="person_info_left">
            <span></span>
          </div>
          <div class="person_info_right">
            <div class="person-info">
              <div class="amount_change">{{ item.currency === 'cny' ? '￥' : '$' }}{{ item.orderAmount }}</div>
              <div class="person_times">{{ item.orderSn }}</div>
            </div>
            <div class="person_status">
              <div class="person_date">
                {{ item.finishTime | date(4) }}
              </div>
            </div>
          </div>
        </li>
      </router-link>
    </ul>
    <div v-if="end" class="endtext">------ 我是有底线的 ------</div>
    <div class="no-data" v-if="nodata">----- 没有消息 -----</div>
    <!-- <div class="loadmore" v-if="allLoaded" @click="loadBottom">加载更多</div> -->
  </div>
</template>

<script>
import ChildHeader from '../components/ChildHeader'
import PartnerApi from '../api/partner'
import storage from '../utils/storage'

export default {
  name: 'gains',
  components: {
    ChildHeader
  },
  data() {
    return {
      title: '累计收益',
      main: '0',
      end: false,
      nodata: false,
      pageIndex: 1,
      pageSize: 8,
      allLoaded: false,
      bottomStatus: '',
      items: [],
      userinfo: storage.getLocalStorage('userinfo')
    }
  },
  mounted: function() {
    this.main = '￥' + this.userinfo.totalAmountCny + ' / $ ' + this.userinfo.totalAmountUsd
  },
  created: function() {
    PartnerApi.getUserOrder(this.userinfo.id).then(
      response => {
        let returnData = response.data
        let records = returnData.data
        if (returnData.success) {
          if (records.length === 0) {
            this.nodata = true
          }
          this.items = records
        }
      },
      response => {
        console.log('error')
      }
    )
  },
  methods: {
    toDetail(value) {
      window.localStorage.detailId = value
    }
  }
}
</script>

<style scoped>
@media (max-width: 750px) {
  .people_info li {
    box-sizing: border-box;
    overflow: hidden;
    width: 100%;
    height: 3.968rem;
    list-style: none;
    border-bottom: 0.0853rem solid rgb(238, 236, 240);
    position: relative;
  }

  .hint {
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.7rem;
    line-height: 3;
    text-align: center;
  }

  .person_info_left {
    float: left;
    position: relative;
    height: 100%;
    width: 1.216rem;
    border-right: 0.0853rem solid rgb(238, 236, 240);
  }

  .person_info_left span {
    display: block;
    width: 0.384rem;
    height: 0.384rem;
    border-radius: 50%;
    background: #00a0e9;
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: -0.192rem;
    margin-right: -0.2147rem;
  }

  .person_info_right {
    box-sizing: border-box;
    float: left;
    height: 100%;
    padding-left: 0.7467em;
    padding-top: 1.1733rem;
    overflow: hidden;
  }

  .amount_change {
    box-sizing: border-box;
    height: 0.96rem;
    font-size: 0.6827rem;
    line-height: 0.96rem;
    text-align: left;
    color: #1d1d26;
    margin-bottom: 0.1067rem;
    margin-top: -0.0853rem;
  }

  .person-info {
    float: left;
    margin-left: 0.4907rem;
  }

  .person_times {
    height: 0.704rem;
    font-size: 0.512rem;
    color: rgb(117, 116, 123);
  }

  .person_date {
    font-size: 0.512rem;
    height: 0.704rem;
    line-height: 0.704rem;
    color: #9b9b9b;
    text-align: right;
  }

  .person_status {
    position: absolute;
    right: 1.0667rem;
    top: 2.1333rem;
  }

  .no-data,
  .endtext,
  .loadmore {
    font-size: 0.6rem;
    margin: 0.5rem 0;
    color: rgba(0, 0, 0, 0.4);
    text-align: center;
  }
}
@media (min-width: 750px) {
  .gains {
    position: relative;
  }
  .people_info {
    background: #faf8fb;
  }
  .people_info li {
    box-sizing: border-box;
    overflow: hidden;
    width: 100%;
    height: 186px;
    list-style: none;
    border-bottom: 2px solid rgb(238, 236, 240);
    position: relative;
  }

  .hint {
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.7rem;
    line-height: 3;
    text-align: center;
  }

  .person_info_left {
    float: left;
    position: relative;
    height: 100%;
    width: 57px;
    border-right: 2px solid rgb(238, 236, 240);
  }

  .person_info_left span {
    display: block;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #00a0e9;
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: -10px;
    margin-right: -10px;
  }

  .person_info_right {
    box-sizing: border-box;
    float: left;
    height: 100%;
    padding-left: 37px;
    padding-top: 51px;
    overflow: hidden;
  }

  .amount_change {
    box-sizing: border-box;
    height: 45px;
    font-size: 32px;
    text-align: left;
    color: #1d1d26;
    margin-bottom: 5px;
    margin-top: -7px;
  }

  .person_times {
    height: 28px;
    font-size: 24px;
    color: rgb(117, 116, 123);
  }

  .person_date {
    font-size: 24px;
    height: 33px;
    color: #9b9b9b;
    text-align: right;
  }

  .person_status {
    position: absolute;
    right: 50px;
    top: 90px;
  }

  .no-data,
  .endtext,
  .loadmore {
    font-size: 20px;
    margin: 20px 0;
    color: rgba(0, 0, 0, 0.4);
    text-align: center;
  }
  .loadmore {
    cursor: pointer;
  }
}
</style>
